export const EPG_EDITOR_TOOLBAR_EVENT = 'iptv-epg-editor-toolbar';
export const EPG_EDITOR_FILTER_STATE_EVENT = 'iptv-epg-editor-filter-state';
export const EPG_EDITOR_STATE_EVENT = 'iptv-epg-editor-state';
export const EPG_EDITOR_RELOAD_EVENT = 'iptv-epg-editor-reload';

export type EpgEditorStateDetail = {
  activeSourceId: number | null;
};

export type EpgEditorToolbarCommand =
  | 'filter-without-epg'
  | 'filter-unassigned'
  | 'filter-clear'
  | 'remove-unassigned-ids'
  | 'apply-shift-from-names';

export type EpgEditorToolbarDetail = {
  command: EpgEditorToolbarCommand;
};

export type EpgEditorFilterStateDetail = {
  withoutEpgActive: boolean;
};
